<div class="reviews-cntnr">

  <div class="review-box" *ngFor="let review of reviews">
    <div class="stars">
      <img class="gold-star" src="./assets/images/gold_star_full.png" alt="">
      <img class="gold-star" src="./assets/images/gold_star_full.png" alt="">
      <img class="gold-star" src="./assets/images/gold_star_full.png" alt="">
      <img class="gold-star" src="./assets/images/gold_star_full.png" alt="">
      <img class="gold-star" src="./assets/images/gold_star_full.png" alt="">
    </div>
    <div class="r-title">
      <span class="open-quote">“</span>
      {{review.title}}
    </div>
    <div class="r-text">{{review.text}}</div>
    <div class="r-subline">{{review.subline}}</div>
  </div>

</div>
